module.exports = __webpack_public_path__ + "static/img/1023_small.66bdfa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1023_small.png
// module id = hT+a
// module chunks = 1